import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { EModalOutput } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { EmployerAgencySearchComponent } from '../employer-agency-search-form/employer-agency-search-form.component';
import {
  EmployerTableRow,
  prev_spostamento_iscritto_table_keys,
} from './spostamento-iscritto.constants';
import { IEmployer } from 'src/app/modules/shared/models/operation.model';

@Component({
  selector: 'app-spostamento-iscritto',
  templateUrl: './spostamento-iscritto.component.html',
  styleUrl: './spostamento-iscritto.component.scss',
})
export class SpostamentoIscrittoComponent implements OnInit, OnChanges {
  @Input() currentEmployerData: IEmployer[];
  @Output() modifiedData: EventEmitter<any> = new EventEmitter<any>();

  public currentEmployerTableKeys: ITableKey[];
  public currentEmployerTableData: any[] = [];

  constructor(private readonly _dialog: MatDialog) {}

  ngOnInit(): void {
    this.currentEmployerTableKeys = CommonUtils.assign(
      prev_spostamento_iscritto_table_keys
    );
    // this.populateTableData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentEmployerData?.currentValue) {
      this.populateTableData();
    }
  }

  public addEmployer(): void {
    this._dialog
      .open(EmployerAgencySearchComponent, {
        minWidth: '70vw',
        minHeight: '60vh',
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((outcome) => {
        if (outcome && outcome.command === EModalOutput.CONFIRM) {
          this.currentEmployerData.push(outcome.data);
          this.populateTableData();
          this.modifiedData.emit(this.currentEmployerData);
        }
      });
  }

  populateTableData(): void {
    if (this.currentEmployerData.length)
      this.currentEmployerTableData = this.currentEmployerData.map(
        (employer) => {
          return {
            ...employer,
            isPureDisabled: parseInt(employer.registryId) > 0,
          };
        }
      );
  }
}
